<div class="hamburger" *ngIf="router.url != '/home'">
    <h2>Recommend for DD Payment</h2>
</div>
<div class="container-fluid bg">
    <div class="container row mx-auto bgFilter">
        <div class="col-sm-3 col-md-3">
            <label class="form-control-label req" [ngClass]="fontService.labelClass">Project
                Name</label>
            <ng-select id="department" bindLabel="projectName" appearance="outline"
                [(ngModel)]="stage2SearchFilter.project" [items]="projectList" class="form-control"
                (change)="getExtent('projectName')" (change)="selectProject($event)" appNgSelectInputRestriction>
            </ng-select>
        </div>
        <div class="col-sm-3 col-md-3">
            <label class="form-control-label req" [ngClass]="fontService.labelClass">Districts</label>
            <ng-select id="department" bindLabel="name" appearance="outline" (change)="SelectDistrict($event)"
                (change)="getExtent('district')" [(ngModel)]="stage2SearchFilter.district" [items]="districkList"
                class="form-control" appNgSelectInputRestriction>
            </ng-select>
        </div>
        <div class="col-sm-3 col-md-3">
            <label class="form-control-label req" [ngClass]="fontService.labelClass">Taluk</label>
            <ng-select id="type" [items]="taluk" bindLabel="name" appearance="outline" [closeOnSelect]="true"
                [clearable]="true" class="form-control" (change)="OnSelectTaluk($event)" (change)="getExtent('taluk')"
                [(ngModel)]="stage2SearchFilter.taluk" [ngClass]="{ 'is-invalid': ngSelectInvalid && !project.scheme }"
                appNgSelectInputRestriction>
            </ng-select>
        </div>
        <div class="col-sm-3 col-md-3">
            <label class="form-control-label req" [ngClass]="fontService.labelClass">Village</label>
            <ng-select id="type" [items]="villages" bindLabel="name" (change)="OnSelectVillage($event)"
                appearance="outline" [closeOnSelect]="true" [clearable]="true"
                class="form-control" [(ngModel)]="stage2SearchFilter.village"
                [ngClass]="{ 'is-invalid': ngSelectInvalid && !project.scheme }" appNgSelectInputRestriction>
            </ng-select>
        </div>
        <div class="col-sm-3 col-md-3">
            <label class="form-control-label req" [ngClass]="fontService.labelClass">Survey Number</label>
            <ng-select id="type" [items]="surveyNo" bindLabel="name" (change)="OnSelectSurvey($event)"
                 appearance="outline"
                [closeOnSelect]="true" [clearable]="true" class="form-control" [(ngModel)]="stage2SearchFilter.surveyNo"
                [ngClass]="{ 'is-invalid': ngSelectInvalid && !project.scheme }" appNgSelectInputRestriction>
            </ng-select>

        </div>
        <div class="col-sm-3 col-md-3">
            <label class="form-control-label req" [ngClass]="fontService.labelClass">Sub-division number</label>
            <ng-select id="type" [items]="subDiv" bindLabel="name" (change)="OnSelectSubdivision($event)"
                 (change)="getExtent('subDiv')" appearance="outline"
                [closeOnSelect]="true" [clearable]="true" class="form-control" [(ngModel)]="stage2SearchFilter.subDiv"
                [ngClass]="{ 'is-invalid': ngSelectInvalid && !project.scheme }" appNgSelectInputRestriction>
            </ng-select>
        </div>
        <div class="col-sm-3 col-md-3">
            <label class="form-control-label req" [ngClass]="fontService.labelClass">Total extent Acquired(In
                hectares)</label>
            <input type="text" class="form-control" name="name" readonly  style="background: lightgray; text-transform:uppercase"[(ngModel)]="stage2SearchFilter.totalExtent"
                [ngClass]="{ 'is-invalid': ngSelectInvalid && !project.workId}" id="name" />
        </div>
        <div class="col-sm-3 col-md-3 mt-3">
            <p-button label="Submit" class="" (click)="getSurvey()"></p-button>
        </div>
    </div>
    <div class="container tableDesign mt-3" *ngIf="isShowTable">
        <p-table [value]="products" [tableStyle]="{ 'width': '100px' ,margin:'auto'}" class="mt-4">
            <ng-template pTemplate="header">
                <tr>
                    <th style="background-color: #017DC3;">Total amount allotted
                        for project</th>
                        <th style="background-color: #017DC3;">Total amount available for project
                            for Project</th>
                    <th style="background-color: #017DC3;">Total amount already
                        paid</th>
                    <th style="background-color: #017DC3;">Total amount for which
                        fund transfer is
                        pending</th>
                    <th style="background-color: #017DC3;">Balance amount</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body">
                <tr>
                    <td>
                        {{amountDetails.totalAmountAllocatedForProject |currency:'INR'}}
                    </td>
                    <td>
                        {{amountDetails.totalAmountAvailableForProject |currency:'INR'}}
                    </td>
                    <td>
                        {{amountDetails.totalAmountAlreadyPaid |currency:'INR'}}
                    </td>
                    <td>
                        {{amountDetails.totalAmountForWhichFundTransferIsPending |currency:'INR'}}
                    </td>
                    <td>
                        {{amountDetails.balanceAmount |currency:'INR'}}
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
    <div class=" mt-3" *ngIf="isShowTable">
        <div #customerTable id="entities" class="col-md-12 mt-3">
            <p-table [value]="beneficiaryData" dataKey="id">
                <ng-template pTemplate="header">
                    <tr>
                        <th style="background-color: #017DC3;">S.No</th>
                        <th style="background-color: #017DC3;">Award proceeding no
                        </th>
                        <th class="text-center" style="background-color: #017DC3;">Award proceeding date</th>
                        <th style="background-color: #017DC3;">Beneficiary details and remark for
                            court deposit
                        </th>
                        <th style="background-color: #017DC3;">Extend of land own
                        </th>
                        <th style="background-color: #017DC3;">DD in favour of
                        </th>
                        <th style="background-color: #017DC3; color: white;">
                            IFSC Code</th>

                        <th style="background-color: #017DC3; color: white;" class="text-center">
                            Bank Name
                        </th>
                        <th style="background-color: #017DC3; color: white;">
                            Branch Name
                        </th>
                        <th style="background-color: #017DC3; color: white;">
                            DD Remitter Name
                        </th>
                        <th style="background-color: #017DC3; color: white;">
                            Payable at
                        </th>
                        <th style="width:100px;background-color: #017DC3; color: white;">
                            Amount
                        </th>
                        <th style="background-color: #017DC3; color: white;"> Action</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-beneficary let-expanded="expanded" let-rowIndex="rowIndex">
                    <tr>
                        <td>
<!-- 
                            <button type="button" *ngIf="beneficary.beneficiaryLandOwnerCustomLegalDto.length != 0"
                                pButton pRipple [pRowToggler]="beneficary"
                                class="p-button-text p-button-rounded p-button-plain"
                                [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button> -->

                                {{rowIndex+1}}
                        </td>
                        <td>{{beneficary.proceedingNo}}</td>
                        <td>{{beneficary.proceedingDate | tabledate}}</td>
                        <td>{{beneficary.remark}}</td>
                        <td>{{beneficary.extentOwned}}</td>
                        <td>{{beneficary.favour}}</td>
                        <td>{{beneficary.ifscCode}}</td>
                        <td class="text-uppercase">{{beneficary.bankName}}</td>
                        <td>{{beneficary.branchName}}</td>
                        <td>{{beneficary.remmiter}}</td>
                        <td>{{beneficary.payable}}</td>
                        <td>{{beneficary.amount |indianRupee  }}</td>
                        <td>
                            <p-checkbox [binary]="true" inputId="binarEntend of landy"
                                (onChange)="generateVoucher($event,beneficary,rowIndex)"></p-checkbox>
                        </td>
                    </tr>

                </ng-template>
                <ng-template pTemplate="footer" >
                    <tr style="background: rgba(1, 125, 195, 0.05) !important;" *ngIf="totalAmount">
                        <th colspan="10" class="footer">
                            <h5 class="total">Total</h5>
                            <h5  *ngIf="extraAmountWarning" class="warning_text">Total amount should not exceed balance amount</h5>
                        </th>
                        <th class="footer">
                            {{totalAmount |indianRupee }}
                        </th>
                        <th>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="rowexpansion" let-beneficary>
                    <tr>
                        <td colspan="12">
                            <div class="p-3">
                                <p-table [value]="beneficary.beneficiaryLandOwnerCustomLegalDto" dataKey="id">
                                    <ng-template pTemplate="header">
                    <tr>
                        <th scope="col" style="background-color: #017DC3;">Legal heir Name </th>
                        <th scope="col" style="background-color: #017DC3;">Mobile No </th>
                        <th scope="col" style="background-color: #017DC3;">Name of Bank </th>
                        <th scope="col" style="background-color: #017DC3;">Account No </th>
                        <th scope="col" style="background-color: #017DC3;">Aadhaar No </th>
                        <th scope="col" style="background-color: #017DC3;">Amount </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-order>
                    <tr>
                        <td>{{ order.benificiaryLandOwnerName }}</td>
                        <td>{{ order.mobileNumber }}</td>
                        <td>{{ order.nameOfBank }}</td>
                        <td>{{ order.accountNumber }}</td>
                        <td>{{ order.aadharNumber }}</td>
                        <td>{{ order.compensationAmount | currency: 'INR' }}</td>
                    </tr>
                </ng-template>

            </p-table>
        </div>
        </td>
        </tr>
        </ng-template>
        </p-table>
        <div class="text-center" *ngIf="totalCount == 0">
            <img src="../../../assets/img/notFound.png" width="419px" alt="">
        </div>
        <div class="flex mt-3" *ngIf="totalCount != 0">
            <p-button label="Recommended for payment" [disabled]="enableGenerateVoucher" class="submit"
                (click)="recommended()"></p-button>
        </div>
        <form ngNoForm action="https://emgateway.emsigner.com/eMsecure/V3_0/Index" method="POST">
            <input id="Parameter1" name="Parameter1" type="hidden" [value]='param1' />
            <input id="Parameter2" name="Parameter2" type="hidden" [value]='param2' />
            <input id="Parameter3" name="Parameter3" type="hidden" [value]='param3' />



            <button *ngIf="enableSignButton" pButton pRipple onclick="submit()" type="submit"
                class="p-button-success custom-button approve_btn">
                <span class="button-label" [ngClass]="fontService.buttonClass">perform E-sign</span>
            </button>

        </form>
    </div>
</div>

<p-dialog header="Payment Details" [(visible)]="visible" (onHide)="hide()" [modal]="true" [style]="{ width: '80vw' }"
    [draggable]="false" [resizable]="false">
    <div class="row payment">
        <table class="table table-striped">
            <thead>
                <tr>
                    <th scope="col">S.No</th>
                    <th scope="col">Name</th>
                    <th scope="col">Survey No</th>
                    <th scope="col">Subdivison No</th>
                    <th scope="col">Bank</th>
                    <th scope="col">Bank Branch</th>
                    <th scope="col">Ifsc Code</th>
                    <th scope="col">Payable At</th>
                    <th scope="col">Amount</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let data of temp; let i=index">
                    <td>{{i+1}}</td>
                    <td>{{data.favour}}</td>
                    <td>{{data.surveyNumber}}</td>
                    <td>{{data.subDivisionNumber}}</td>
                    <td>{{data.bankName}}</td>
                    <td>{{data.branchName}}</td>
                    <td>{{data.ifscCode}}</td>   
                    <td>{{data.payable}}</td>
                    <td>{{data.amount}}</td>
                </tr>

            </tbody>
        </table>
    </div>
    <div>
        <p-button label="Generate Voucher" class="submit mx-auto" (click)="submit()"></p-button>
    </div>
</p-dialog>

</div>